import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { RoutesList } from '@cycle-hangars/routes/Routes';
import { useCycleStore } from '@cycle-hangars/store/store';
import { CaseIDProps } from '@cycle-hangars/store/storeSlices/issueDetails';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const submitData = async (payload: any) => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_APIM_BASE_URL}/report/v1/vehicles/cyclehangars`,
      {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Ocp-Apim-Subscription-Key': `${import.meta.env.VITE_APIM_API_KEY as string}`,
          'content-type': 'application/json',
        },
      },
    );
    const submitResponse = (await response.json()) as CaseIDProps;
    if (!submitResponse || !submitResponse.case_reference) {
      throw new Error('Failed to submit report');
    }
    return submitResponse;
  } catch (error) {
    throw new Error((error as Error).message);
  }
};

export const useHandleSubmit = () => {
  const navigate = useNavigate();
  const { updateConfirmation, updateCaseReferenceId, updateSlaText } =
    useCycleStore();

  return useMutation({
    mutationFn: submitData,
    onSuccess: (data) => {
      const result = data as CaseIDProps;
      updateConfirmation(result);
      updateCaseReferenceId(result.case_reference);
      updateSlaText(result.sla_text);
      navigate(RoutesList.CONFIRMATION);
    },
    onError: (error) => {
      Sentry.captureException(error);
      navigate(RoutesList.CONFIRMATION);
    },
  });
};
